var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModuleContainer',[(_vm.loaded)?_vm._l((_vm.c_layers),function(layer){return _c('Layer',_vm._g(_vm._b({key:layer.id},'Layer',_vm.getBindLayer(layer),false),_vm.getEventLayer(layer)))}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }